import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoChevronDown, IoCheckmark } from 'react-icons/io5';
import { useRouter } from 'next/router';

const sortOptions = [
  {
    id: 'newest',
    name: 'Newest Arrivals',
    orderBy: 'created_at',
    sortedBy: 'DESC',
  },
  {
    id: 'price-low-to-high',
    name: 'Prices (Low to High)',
    orderBy: 'min_price',
    sortedBy: 'ASC',
  },
  {
    id: 'price-high-to-low',
    name: 'Prices (High to Low)',
    orderBy: 'min_price',
    sortedBy: 'DESC',
  },
  {
    id: 'best-selling',
    name: 'Best Selling',
    orderBy: 'sold_quantity',
    sortedBy: 'DESC',
  },
];

export function SortFilters() {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation('common');
  const router = useRouter();
  const { pathname, query } = router;

  // Normalize current sort (case insensitive)
  const currentOrderBy =
    (query.orderBy as string)?.toLowerCase() || 'created_at';
  const currentSortedBy = (query.sortedBy as string)?.toUpperCase() || 'DESC';
  const currentSort = `${currentOrderBy}-${currentSortedBy}`;

  const handleSortChange = (orderBy: string, sortedBy: string) => {
    // Don't navigate if already selected
    if (currentSort === `${orderBy.toLowerCase()}-${sortedBy.toUpperCase()}`) {
      return;
    }

    router.push(
      {
        pathname,
        query: {
          ...query,
          orderBy,
          sortedBy,
        },
      },
      undefined,
      { scroll: false },
    );
  };

  return (
    <div className="block mb-2">
      <h3
        className="text-[#333333] text-sm md:text-lg mb-5 flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>Sort By</span>
        <IoChevronDown
          className={`transition-transform duration-200 text-[#9D9D9D] ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </h3>
      {isOpen && (
        <div className="mt-2 flex flex-col space-y-1">
          {sortOptions.map((option) => {
            const isSelected =
              currentSort ===
              `${option.orderBy.toLowerCase()}-${option.sortedBy.toUpperCase()}`;
            return (
              <div
                key={option.id}
                onClick={() =>
                  handleSortChange(option.orderBy, option.sortedBy)
                }
                className={`text-body text-sm cursor-pointer hover:bg-[#2819140A] p-2 rounded transition-colors flex items-center justify-between ${
                  isSelected ? 'bg-[#2819140A] font-semibold text-heading' : ''
                }`}
              >
                <span>{option.name}</span>
                {isSelected && (
                  <IoCheckmark className="text-heading" size={18} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
